module.exports = require('./helpers/bundle-url').getBundleURL('9U9Lq') + "church-banner.4022d9a9.png";